module.exports = __webpack_public_path__ + "media/damages/miejsce-uszkodzenia-e0983177.png";